import { createStore, compose, applyMiddleware } from 'redux';
import rootReducer from '../reducers';
import promise from 'redux-promise';

export default function configureStore(initialState) {
  let store = createStore(rootReducer, initialState, compose(
    // Add other middleware on this line...
    applyMiddleware( promise ),
    window.devToolsExtension ? window.devToolsExtension() : f => f //add support for Redux dev tools
    )
  );

  return store;
}
